/**
 * Property search bar service
 * @author Bálint Ádám 2017.07.03.
 */

export class PropertySearchBarService {
	constructor($http) {
		'ngInject';
		this.$http = $http;
	}
	getPublicLocation(searchText) {
		return this.$http.get('/public/location?input=' + searchText).then(
			response => {
				return response.data;
			},
			() => {
				return [];
			}
		);
	}
}
